export const compose = (...funcs) => x => funcs.reduceRight((a, b) => b(a), x);
export const v$ = (string, parent, importance) => {
    var parent = parent ? parent : document,
        elements = parent.querySelectorAll(string);
        importance = importance || importance === 0 ? importance : 1;
    if (!elements.length > 0) {
        // if (importance > 1) {
        //     throw new Error('No items with a selector: ' + string);
        // } else if (importance > 0) {
        //     console.warn('No items with a selector: ' + string);
        // }
        return false;
    } else {
      return elements;
    }
};
export const Foreach = (element, callback) => {
    let elems = element.length > 0 ? element : [element];
    for (var i = 0; i < elems.length; i++) {
        callback(elems[i], i);
    }
}
export var listen = function (element, event, calbak) {
    var elem = element.length > 0 ? element : element !== false ? [element] : false;
    if (elem) {
        for (var i = 0; i < elem.length; i++) {
            elem[i].addEventListener(event, calbak);
        }
    }
}
export const toggleClass = (target, className) => {
    if (target.className.includes(className)) {
        target.classList.remove(className);
    } else {
        target.classList.add(className);
    }
}
export const Parents = (target, parentClassName, level) => {
    let parent = target,
        isHere = false,
        stop = false;
    for (let i = 0; i < level; i++) {
        if (!stop) {
            let parentParent = parent.parentNode;
            stop = parentParent ? false : true;
            if (parentParent === v$(`.${parentClassName}`)[0]) {
                parent = parentParent;
                isHere = true;
            } else if (!isHere) {
                parent = parent.parentNode;
            }
        }
        else {
            return parent;
        }
    }
    return parent;
}
export const validation = (target, regex) => {
    let elements = target.length > 0 ? target : [target];
    elements.forEach(item => {
        item.addEventListener('change', e => {
            let parent = e.target.parentNode;
            if (!regex.test(e.target.value)) {
                parent.classList.add('has-error');
            } else {
                parent.classList.remove('has-error');
            }
        })
    })
}
export const generateBooleanArr = (trueCount, count) => {
    let arr = [];
    for (let i = 1; i <= count; i++) {
        if (i <= trueCount) {
            arr.push(true);
        } else {
            arr.push(false);
        }
    }
    return arr;
}
export const lastByIndex = (arr, index) => arr[arr.length - index];
export const getHeight = target => {
    target.style.height = 'auto';
    let height = target.scrollHeight;
    target.style.height = '0';
    return height;
}
export const composeM = chainMethod => (...ms) => (
    ms.reduceRight((f, g) => x => f(x)[chainMethod](g))
);
export const composePromise = composeM('done');
export const toggleHeight = target => {
    let isOpened = target.className.includes('open'),
        height = isOpened ? '0' : getHeight(target) + 'px',
        targetTransition = Number(window.getComputedStyle(target).getPropertyValue('transition-duration').split('s')[0]);
    target.style.height = isOpened ? getHeight(target) + 'px' : 0;
    let timeOut = setTimeout(() => {
        target.style.height = height;
        isOpened ? target.classList.remove('open') : target.classList.add('open');
        clearTimeout(timeOut);
    }, 40);
    let setAutoHeight = setTimeout(() => {
        target.style.height = isOpened ? 0 : 'auto';
        clearTimeout(setAutoHeight);
    }, targetTransition * 1000);
};

export const initMap = ({data, zoom, center, element}) => {
    const locations = data.map(item => {
        return item.position;
    });
    let directionBtn = v$('.js-direction', false, 0)[0],
        directionInput = v$('.js-direction-input', false, 0)[0];
    const directionsDisplay = new google.maps.DirectionsRenderer();
    const directionsService = new google.maps.DirectionsService();
    const map = new google.maps.Map(element, {
        zoom,
        center
    });
    const autocomplete = new google.maps.places.Autocomplete(directionInput);
    autocomplete.bindTo('bounds', map);
    const geocoder = new google.maps.Geocoder;
    const markers = locations.map((location, i) => {
        return new google.maps.Marker({
            position: location,
            icon: data[i].withShop ? '/img/Pin_map_yellow.png' : '/img/pin_map_red.png'
        });
    });
    let infowindow = new google.maps.InfoWindow({
        content: ''
    });
    markers.forEach(marker => {
        marker.addListener('click', function(e) {
            let itemData = data.filter(item => item.position.lat === e.latLng.lat())[0];
            let content =
                '<div class="offices-detail active" id="offices-detail">\n' +
                '<div class="offices-detail-branch"><span>' + JSI18N.t('frontend.one_office', 'office') +' '+ itemData.number +'</span></div>\n' +
                '<div class="offices-detail-title"><span>' + itemData.city_name + ', ' + itemData.address  +'</span></div>\n' +
                '<div class="offices-detail-subtitle"><span>'+ itemData.referencePoint  +'</span></div>\n' +
                '<div class="offices-detail-work-time"><span class="work-time-title">'+JSI18N.t('frontend.one_office', 'work_time')+'</span>' +
                '<span class="work-time-dscr">'+ itemData.workTime  +'</span></div>';
            if (itemData.officeHref)
            {
                content += '<a class="offices-detail-link" href="'+ itemData.officeHref+'">'+JSI18N.t('frontend.one_office', 'more')+'</a>\n';
            }
            content += '</div>';
            infowindow.setContent(content.replace(/undefined/g,''));
            infowindow.open(map, marker);
        });
    });
    const markerCluster = new MarkerClusterer(
        map,
        markers,
        {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'}
    );
    const setRouteToNearest = (userPosition) => {
        let distanceies = [];
        locations.forEach((item, index) => {
            let officePosition = new google.maps.LatLng(item.lat, item.lng);
            let d = google.maps.geometry.spherical.computeDistanceBetween(userPosition, officePosition);
            distanceies.push({
                d: parseInt(d.toFixed(0)),
                index
            })
        });
        const nearest = distanceies.sort((a, b) => a.d - b.d)[0];
        const request = {
            origin: userPosition,
            destination: locations[nearest.index],
            travelMode: 'DRIVING'
        };
        directionsService.route(request, (result, status) => {
            if (status === 'OK') {
                directionsDisplay.setDirections(result);
                directionsDisplay.setMap(map);
            }
        });
    };
    const nearestDirection = (userPosition) => {
        if (!userPosition) {
            navigator.geolocation.getCurrentPosition(pos => {
                const userPosition = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
                setRouteToNearest(userPosition);
            });
        }
        else {
            setRouteToNearest(userPosition);
        }
        // navigator.geolocation.getCurrentPosition( pos => {
        //     const userPosition = new google.maps.LatLng(pos.coords.latitude,pos.coords.longitude);
        // let distanceies = [];
        // locations.forEach((item,index) => {
        //     let officePosition = new google.maps.LatLng(item.lat,item.lng);
        //     let d = google.maps.geometry.spherical.computeDistanceBetween(userPosition,officePosition);
        //     distanceies.push({
        //         d:parseInt(d.toFixed(0)),
        //         index
        //     })
        // });
        // const  nearest  = distanceies.sort((a,b) => a.d - b.d)[0];
        // const request = {
        //     origin: userPosition,
        //     destination: locations[nearest.index],
        //     travelMode: 'DRIVING'
        // };
        // directionsService.route(request, (result, status) => {
        //     if (status ==='OK') {
        //         directionsDisplay.setDirections(result);
        //         directionsDisplay.setMap(map);
        //     }
        // });
        // });
    };
    if (directionBtn) {
        listen(directionBtn, 'click', () => nearestDirection());
    }
    if (directionInput) {
        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            nearestDirection(place.geometry.location);
        });
    }
};

export const renderList = (data, func, container) => {
    data.forEach((item, index) => func(item, index, container));
};
export const triger = (elements, direction, offset, f) => {
    let isPerCent = offset.indexOf('%') !== -1,
        windowHeight = window.innerHeight;
    if (isPerCent) {
        let onePerCent = windowHeight / 100,
            offset = parseInt(offset) * onePerCent;
    } else {
        offset = parseInt(offset);
    }
    for (let i = 0; i < elements.length; i++) {
        if (elements[i].getBoundingClientRect()[direction] <= windowHeight - offset) {
            f(elements[i]);
        }
    }
};
export const checkIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
export const scroll = (offset, direction) => {
    const animateFunction = () => {
        const step = direction === 'top' ? -25 : 25;
        const boolean = direction === 'top' ? window.pageYOffset > offset - 25 : window.pageYOffset < offset - 25;
        if (boolean) {
            window.scrollBy(0, step);
            requestAnimationFrame(animateFunction)
        }
        else {
            return true;
        }
    };
    requestAnimationFrame(animateFunction);
};
export const getLang = () => process.env.NODE_ENV === 'development'
    ? ''
    : window.JSI18N.activeLanguage.code === window.JSI18N.defaultLanguage.code
        ? ''
        : '/' + window.JSI18N.activeLanguage.code;

export const loadPriceTechData = function ($callBack) {
  if (!window.price_tech){
    $.ajax({
      url: '/api/data/price-tech',
      success: (data) => {
        for (let i in data) {
          window[i] = data[i];
        }
        if(typeof($callBack) === "function"){
          $callBack();
        }
      }
    })
  }else if(typeof($callBack) === "function"){
    $callBack();
  }
}
